import { useEffect } from "react";

export const useTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const PageHero = ({ image, eyebrow, title, text, children, testid, accent }) => {
  const renderTitle = () => {
    if (!accent || !title.includes(accent)) return title;
    const idx = title.indexOf(accent);
    return (
      <>
        {title.slice(0, idx)}
        <span className="font-brand text-gold">{accent}</span>
        {title.slice(idx + accent.length)}
      </>
    );
  };
  return (
  <section className="noise relative overflow-hidden border-b border-seam pt-[72px]" data-testid={testid}>
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-obsidian/80 to-obsidian" />
      </>
    )}
    <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-spark">{eyebrow}</p>
      <h1 className="mt-4 max-w-4xl font-display text-5xl font-black uppercase leading-[0.92] tracking-tight text-frost sm:text-6xl lg:text-7xl">
        {renderTitle()}
      </h1>
      {text && <p className="mt-6 max-w-2xl text-base leading-relaxed text-cadmium sm:text-lg">{text}</p>}
      {children}
    </div>
  </section>
  );
};
